import UrlService from '../url/urlService';
import UrlUtils from '../../../utils/http/url';


class Settings {

	constructor() {
		this.props  = {};
		UrlUtils.addGlobalPathParams({
			accountId: this.getTenantOrganizationId(),
			domainName: this.getDomainName(),
			applicationKey: this.getApplicationKey()
		});

		let baseUrl = UrlService.getSearchParam('baseUrl');
		if(baseUrl) {
			UrlUtils.setBaseUrl(baseUrl);
		}
	}

	set(settings) {
		if(settings.baseUrl) {
			UrlUtils.setBaseUrl(settings.baseUrl);
		}

		if(settings.accountId) {
			this.accountId = settings.accountId;
		}

		if(settings.appKey) {
			this.appKey = settings.appKey;
		}

		if(settings.environmentName) {
			this.environmentName = settings.environmentName;
		}

		if(settings.domainName) {
			this.domainName = settings.domainName;
		}

		if(settings.variables) {
			this.variables = settings.variables;
		}

		UrlUtils.addGlobalPathParams({
			accountId: this.getTenantOrganizationId(),
			domainName: this.getDomainName(),
			applicationKey: this.getApplicationKey()
		});
	}

	getTenantOrganizationId() {
		let tenantName = this.accountId || UrlService.getSearchParam('accountId');
		return tenantName;
	}

	getApplicationKey() {
		let appkey = this.appKey || UrlService.getSearchParam('appkey');
		if(!appkey) {
			//throw new Error('missing appkey in the url');
		}
		return appkey;
	}

	getEnvironmentName() {
		let environmentName = this.environmentName || UrlService.getSearchParam('Environment-Name');
		if(!environmentName) {
			environmentName = 'Dev'
		}
		return environmentName;
	}

	getDomainName() {
		let domainName = this.domainName || UrlService.getSearchParam('domainName');
		return domainName;
	}

	isDebugMode() {
        let mode = UrlService.getSearchParam('mode');

        if (mode) {
            switch (mode.toLowerCase()) {
                case "admin":
                case "designer":
                    return true;

                default:
                    return false;
            }
        }
        else {
        	return false;
		}
	}

	setRpaBotId(botId){
		this.rpaBotId = botId;
	}

	getRpaBotId(botId){
		return this.rpaBotId;
	}

	setSessionId(sessionId) {

		this.sessionId = sessionId;

		UrlUtils.addGlobalQueryParams({sessionId: this.sessionId});
	}

	getSessionId(){
		return this.sessionId;
	}

	setProp(key, value){
		this.props[key] = value;
	}

	getProp(key){
		return this.props[key];
	}

	getVariables() {
		return this.variables;
	}
}

export default new Settings();


// WEBPACK FOOTER //
// ../common/services/src/settings/settings.js